module.exports=function(scope){ return `${scope.fSubject}
${scope.fDate}
${scope.fNum}`};